import { number, object, string } from "superstruct";

const InstagramBaseStorySchema = object({
    id: number(),
    photoUrl: string(),
    ownerId: number(),
    ownerUsername: string(),
    ownerImage: string(),
    objectLink: string(),
    objectId: string(),
    galleryId: number(),
});

export default InstagramBaseStorySchema;
